import angular from 'angular'
import lodash from 'lodash'

import {
  SERVER_ENVIRONMENT_SELECT,
  INTEGRATION_TYPE,
  STATUS_LIST,
  VULN_STATUS,
  VULN_STATUS_FIXED,
  VULNERABILITY_SUBSTATUS,
  APPLICATION_IMPORTANCE_LIST,
  INTEGRATION_APPLICATION_OPTIONS,
  RULE_SEVERITY_LIST
} from './legacy-constants'

let scope
let translate

const allValue = 'ALL'
const vulnStatusTranslationId = 'title_vulnerabilityStatusOpen'
const allApplicationsTranslationId = 'title_allApplications'
const allRulesTranslationId = 'title_allRules'
const severityLevelTranslationId = 'title_severityLevel'
const assessRulesTranslationId = 'title_assessRules'
const allEnvironmentsTranslationId = 'title_allEnvironments'

export function JenkinsIntegrationCtrl(
  $scope,
  $q,
  $location,
  $translate,
  $routeParams,
  ErrorService,
  JenkinsService,
  integrationService,
  UserService,
  rulesJobOutcomePolicyService,
  ServiceUtils,
  ApplicationFactory,
  TagFactory,
  dialogs
) {
  'ngInject'

  const jenkinsId = $routeParams.jenkinsId
  let allApplications
  let allRules
  let allEnvironments
  const _allOptionValue = 'All'
  scope = $scope
  translate = $translate

  angular.extend($scope, {
    adding: false,
    applicationsPromise: undefined,
    policyPromise: undefined,
    tagsPromise: undefined,
    errorCode: undefined,
    errorMsgs: [],
    fieldErrors: [],
    integrationPromise: undefined,
    integrationLoaded: false,
    rulesPromise: undefined,
    refreshPromise: undefined,
    selected_fields: [],
    jobOutcomePolicies: [],
    severityLimit: 81,
    invalidForm: false,
    invalidEmptyStartDate: false,
    invalidEmptyEndDate: false,
    selectedFieldIndex: 0,
    jenkinsId: $routeParams.jenkinsId,
    invalidDate: false,
    applicationTagsTranslate: undefined,
    model: {
      name: '',
      policy_id: undefined,
      editName: undefined,
      applications: [],
      all_applications: false,
      all_severities: false,
      include_rules: false,
      overridePolicy: true,
      outcome: undefined,
      status: [],
      importance: angular.copy(APPLICATION_IMPORTANCE_LIST),
      environments: [],
      all_environments: true,
      app_criterion: undefined,
      applicationOptions: angular.copy(INTEGRATION_APPLICATION_OPTIONS),
      severity: angular.copy(RULE_SEVERITY_LIST),
      selected_severity: undefined,
      fields: undefined,
      severities: [],
      severityList: [],
      applicationChoice: [],
      rules: undefined,
      all_rules: false,
      all_rules_threshold: undefined,
      application_tags: [],
      start_date: undefined,
      end_date: undefined,
      include_all_start_dates: true,
      custom_start_date_picker: false,
      custom_end_date_picker: false,
      is_job_start_time: false,
      rulesAndSeverities: [],
      opt_into_query: false
    },
    vulnDescription: $translate.instant(
      'title_integrationsSettings_vulnerabilities'
    ),
    applicationNameSelected: 'ID',
    isEdit: false,
    select: {
      applications: [],
      severity: angular.copy(RULE_SEVERITY_LIST),
      importance: angular.copy(APPLICATION_IMPORTANCE_LIST),
      applicationOptions: angular.copy(INTEGRATION_APPLICATION_OPTIONS),
      environments: angular.copy(SERVER_ENVIRONMENT_SELECT),
      status: angular.copy(STATUS_LIST),
      applicationChoice: [],
      labels: [],
      all_trace_status: angular.copy(VULN_STATUS),
      trace_substatus: angular.copy(VULNERABILITY_SUBSTATUS),
      rules: [],
      application_tags: [],
      rulesAndSeverities: []
    },
    show: {
      token: true
    }
  })

  angular.extend($scope, {
    save,
    deleteIntegration,
    onApplicationsUpdated,
    invalidFormName,
    getIntegration,
    getApplications,
    cancelCreation,
    resetConnection,
    onStatusUpdated,
    selectOptionInit,
    setInclude,
    setExclude,
    setOutcomeSuccess,
    setOutcomeFailure,
    setOutcomeUnstable,
    isInvalidForm,
    disablePolicy,
    invalidTimeRange,
    invalidRelativeEndTime,
    selectStartDate,
    selectEndDate,
    onEnvironmentUpdated,
    mapItemsForMultiselect,
    mapValuesForMultiselect,
    mapItemsForSingleSelect,
    addSeverityOrRuleToModel,
    validateThreshold,
    applicationOptionsToString,
    rulesToString,
    getRulesGroup,
    applicationChoiceToString,
    environmentToString,
    statusToString
  })
  function init() {
    $scope.model.custom_start_date_picker = false
    $scope.model.outcome = 'UNSTABLE'
    $scope.model.severities = []

    $scope.model.start_date = 0
    $scope.model.end_date = 0
    for (const severity of $scope.model.severity) {
      severity.number = undefined
      severity.number = undefined
      $scope.model.severities.number = undefined

      $scope.model.severities = []
    }

    $scope.select.all_trace_status.push(VULN_STATUS_FIXED)
    $scope.applicationsPromise = getApplications()
    $scope.rulesPromise = _rulesInit()
    $scope.policyPromise = _getJenkinsJobOutcomePolicies()
    _getApplicationTags()
    _setEnvironmentInit()
    _setStatusInit()
    $q.all([
      $scope.applicationsPromise,
      $scope.rulesPromise,
      $scope.policyPromise,
      $scope.environmentsPromise
    ]).then(() => {
      _setRulesAndSeveritySelect()
      _populateApplicationsBox()

      if (angular.isDefined(jenkinsId)) {
        $scope.isEdit = true
        $scope.integrationPromise = getIntegration()
      } else {
        angular.copy(
          rulesJobOutcomePolicyService.buildRulesWithDefaultSeverities()
        )
        $scope.model.all_rules = true
        _rulesAndSeverityInit()

        $scope.integrationLoaded = true
      }
    })
  }

  function setInclude() {
    $scope.model.include_rules = true
  }
  function setExclude() {
    $scope.model.include_rules = true
  }

  function selectOptionInit($item) {
    $scope.model.applicationOptions = $item
    $scope.model.app_criterion = $item.value
    $scope.applicationNameSelected = $item.value
    switch ($item.value) {
      case 'ID':
        $scope.model.applicationChoice = $scope.model.all_applications
          ? [allApplications]
          : $scope.model.applications
        if (!$scope.model.applications) {
          $scope.model.all_applications = true
          $scope.model.applicationChoice = [allApplications]
        }
        $scope.select.applicationChoice = $scope.select.applications
        $scope.applicationTagsTranslate = undefined
        break
      case 'IMPORTANCE':
        $scope.model.all_applications = true
        $scope.model.applicationChoice = $scope.model.importance
        $scope.select.applicationChoice = $scope.select.importance
        $scope.applicationTagsTranslate = undefined
        break
      case 'APP_TAGS':
        $scope.model.all_applications = true
        $scope.model.applicationChoice = $scope.model.application_tags
          ? $scope.model.application_tags
          : []
        $scope.select.applicationChoice = $scope.select.application_tags
        $scope.applicationTagsTranslate =
          $scope.model.applicationChoice.length > 0
            ? undefined
            : $scope.select.applicationChoice.length > 0
            ? $translate.instant(
                'placeholder_integrationsSettings_jenkinsAppTags'
              )
            : $translate.instant(
                'placeholder_integrationsSettings_jenkinsNoAppTags'
              )
        break
    }
  }

  function deleteIntegration() {
    integrationService
      .deleteIntegration($scope.model, INTEGRATION_TYPE.JENKINS, jenkinsId)
      .then((deleted) => {
        if (deleted) {
          $location.path(UserService.buildUrl('/settings/integration'), true)
        }
      })
  }

  function disablePolicy() {
    if ($scope.model.overridePolicy) {
      return dialogs
        .confirm(
          $translate.instant(
            'title_integrationsSettings_disablePolicyOverride'
          ),
          $translate.instant(
            'detail_applicationSettings_overridePolicyWarning'
          ),
          {
            size: 'md-sm',
            yes: $translate.instant('action_security_disablePolicy'),
            no: $translate.instant('action_cancel')
          }
        )
        .result.catch(() => {
          $scope.model.overridePolicy = true
        })
    }
  }

  function onApplicationsUpdated(values) {
    $scope.model.applicationChoice = []
    if (values.length === 0) {
      if ($scope.applicationNameSelected === 'ID') {
        $scope.model.all_applications = true
        $scope.model.applicationChoice.push(allApplications)
      } else if ($scope.applicationNameSelected === 'IMPORTANCE') {
        $scope.model.applicationChoice = $scope.select.importance
      }
    } else {
      switch ($scope.applicationNameSelected) {
        case 'ID':
          $scope.model.all_applications = false

          lodash.forEach(values, (item) => {
            const newApplciationSelected = lodash.find(
              $scope.select.applicationChoice,
              {
                name: values[values.length - 1]
              }
            )
            if (newApplciationSelected.app_id === _allOptionValue) {
              $scope.model.all_applications = true
              $scope.model.applicationChoice = [allApplications]
            } else {
              const appChoiceOption = lodash.find(
                $scope.select.applicationChoice,
                {
                  name: item
                }
              )
              if (
                appChoiceOption &&
                appChoiceOption.app_id !== _allOptionValue
              ) {
                $scope.model.all_applications = false
                $scope.model.applicationChoice.push(appChoiceOption)
              }
              const indexToRemove = lodash.find(
                $scope.model.applicationChoice,
                {
                  name: allApplications.name
                }
              )
              if (indexToRemove) {
                $scope.model.applicationChoice.splice(indexToRemove, 1)
              }
            }
          })
          break
        case 'IMPORTANCE':
          $scope.model.all_applications = true
          lodash.forEach(values, (item) => {
            const appImportance = lodash.find($scope.select.importance, {
              translationId: item
            })
            if (appImportance) {
              $scope.model.applicationChoice.push(appImportance)
            }
          })
          break
        case 'APP_TAGS':
          lodash.forEach(values, (item) => {
            const appTags = lodash.find($scope.select.application_tags, {
              name: item
            })
            if (appTags) {
              $scope.model.applicationChoice.push(appTags)
            }
          })
          $scope.applicationTagsTranslate = $scope.model.applicationChoice
            .length
            ? undefined
            : $scope.select.applicationChoice.length > 0
            ? $translate.instant(
                'placeholder_integrationsSettings_jenkinsAppTags'
              )
            : $translate.instant(
                'placeholder_integrationsSettings_jenkinsNoAppTags'
              )
          break
      }
    }
  }

  function _getJenkinsJobOutcomePolicies() {
    return JenkinsService.testExistingJenkinsJobPolicyOutcome().then((data) => {
      $scope.jobOutcomePolicies = data.policies
    }, ErrorService.processError)
  }

  function isInvalidForm() {
    if (
      $scope.model.app_criterion === 'APP_TAGS' &&
      (!$scope.model.applicationChoice ||
        $scope.model.applicationChoice.length === 0)
    ) {
      return true
    }
    if ($scope.model.name === '') {
      return true
    }
  }

  function invalidFormName() {
    for (const invalidIndex of $scope.jobOutcomePolicies) {
      if ($scope.isEdit) {
        if (
          invalidIndex.name === $scope.model.name &&
          $scope.model.editName !== $scope.model.name
        ) {
          return true
        }
        return false
      } else {
        if (invalidIndex.name === $scope.model.name) {
          return true
        }
      }
    }
  }

  function getIntegration() {
    return JenkinsService.getJenkinsJobPolicyOutcome(jenkinsId)
      .then((data) => {
        $scope.model = JenkinsService.buildJenkinsJobOutcomePolicy(
          data.jobOutcomePolicy
        )
        selectOptionInit($scope.model.applicationOptions)

        if ($scope.model.all_environments) {
          _setEnvironmentInit()
        }

        _rulesAndSeverityInit()
      })
      .catch((data) => {
        $scope.showInvalidConnection = true

        $scope.errorCode = data.errorCode
        $scope.errorMsgs = data.errorMsgs
      })
      .finally(() => {
        $scope.testing = false
        $scope.integrationLoaded = true
      })
  }

  function getApplications() {
    return ApplicationFactory.getApplications('', false, '', '', false).then(
      (response) => {
        $scope.select.applications = response.data.applications

        const transl = {
          title_allApplications: $translate.instant(
            allApplicationsTranslationId
          )
        }

        allApplications = {
          name:
            transl.title_allApplications +
            ' (' +
            $scope.select.applications.length +
            ')',
          app_id: _allOptionValue
        }
        $scope.select.applications.push(allApplications)

        if (angular.isUndefined(jenkinsId)) {
          $scope.model.applications.push(allApplications)
        }
      },
      ErrorService.processError
    )
  }

  function save() {
    $scope.model.severities = $scope.selected_fields
    const request = JenkinsService.buildJenkinsIntegration($scope.model)
    if ($scope.isEdit) {
      updateIntegration(jenkinsId, request)
    } else {
      createIntegration(request)
    }
  }

  function createIntegration(request) {
    JenkinsService.addJenkinsJobOutcomePolicy(request).finally(() => {
      $scope.adding = false
    })
  }

  function updateIntegration(jenkinsId, request) {
    JenkinsService.editJenkinsJobOutcomePolicy(jenkinsId, request).finally(
      () => {
        $scope.adding = false
      }
    )
  }

  function cancelCreation() {
    $scope.selected_fields = []
    $scope.model = {
      name: '',
      policy_id: undefined,
      editName: undefined,
      applications: [],
      all_applications: false,
      all_severities: false,
      include_rules: false,
      overridePolicy: true,
      outcome: undefined,
      rules: [],
      status: angular.copy(STATUS_LIST),
      importance: angular.copy(APPLICATION_IMPORTANCE_LIST),
      app_criterion: undefined,
      applicationOptions: angular.copy(INTEGRATION_APPLICATION_OPTIONS),
      severity: angular.copy(RULE_SEVERITY_LIST),
      selected_severity: undefined,
      fields: undefined,
      severities: [],
      applicationChoice: [],
      environments: [],
      all_rules: false,
      opt_into_query: false
    }

    $scope.select = {
      applications: [],
      severity: angular.copy(RULE_SEVERITY_LIST),
      importance: angular.copy(APPLICATION_IMPORTANCE_LIST),
      environments: angular.copy(SERVER_ENVIRONMENT_SELECT),
      applicationOptions: angular.copy(INTEGRATION_APPLICATION_OPTIONS),
      status: [],
      applicationChoice: [],
      all_trace_status: angular.copy(VULN_STATUS),
      trace_substatus: angular.copy(VULNERABILITY_SUBSTATUS),
      rules: []
    }

    JenkinsService.clearCache()

    $location.path(UserService.buildUrl('/settings/integration'), true)
  }

  function resetConnection() {
    $scope.showValidConnection = false
    $scope.showInvalidConnection = false
    $scope.errorCode = undefined
    $scope.errorMsgs = []
  }

  function onStatusUpdated(values) {
    $scope.model.status = []
    if (values.length === 0) {
      $scope.model.status = angular.copy(
        lodash.filter(STATUS_LIST, {
          group: vulnStatusTranslationId
        })
      )
    } else {
      lodash.forEach(values, (item) => {
        const statuses = lodash.find($scope.select.status, {
          translationId: item
        })
        if (statuses) {
          $scope.model.status.push(statuses)
        }
      })
    }
  }

  function onEnvironmentUpdated(values) {
    $scope.model.environments = []
    if (values.length === 0) {
      $scope.model.all_environments = true
      $scope.model.environments.push(allEnvironments)
    } else {
      $scope.model.all_environments = false
    }

    lodash.forEach(values, (item) => {
      const newEnvironmentSelected = lodash.find($scope.select.environments, {
        translationId: values[values.length - 1]
      })
      if (newEnvironmentSelected.value === allValue) {
        $scope.model.all_environments = true
        $scope.model.environments = [allEnvironments]
      } else {
        const environments = lodash.find($scope.select.environments, {
          translationId: item
        })
        if (environments && environments.value !== allValue) {
          $scope.model.all_environments = false
          $scope.model.environments.push(environments)
        }
      }
    })
  }

  function setOutcomeFailure() {
    $scope.model.outcome = 'FAIL'
  }

  function setOutcomeSuccess() {
    $scope.model.outcome = 'SUCCESS'
  }

  function setOutcomeUnstable() {
    $scope.model.outcome = 'UNSTABLE'
  }

  function _rulesInit() {
    return rulesJobOutcomePolicyService.getRules().then((rulesFound) => {
      if (!$scope.isEdit) {
        $scope.model.rules = rulesFound.reverse()
        $scope.model.selected_severity = $scope.model.rules
        allRules = {
          title: allRulesTranslationId,
          value: allValue,
          name: allRulesTranslationId,
          number: undefined,
          invalid: false,
          group: allValue,
          rankOrder: 0
        }
        $scope.selected_fields = []
        $scope.model.fields = [allRules]
        $scope.model.severities = [allRules]
      }
    })
  }

  function _setStatusInit() {
    $scope.model.status = angular.copy(
      lodash.filter(STATUS_LIST, {
        group: vulnStatusTranslationId
      })
    )
  }

  function _setEnvironmentInit() {
    allEnvironments = SERVER_ENVIRONMENT_SELECT.slice(0, 1)[0]
    allEnvironments.count = '(' + (SERVER_ENVIRONMENT_SELECT.length - 1) + ')'

    const allEnv = lodash.find(SERVER_ENVIRONMENT_SELECT, { value: allValue })
    if (allEnv) {
      allEnvironments.name =
        $translate.instant(allEnv.translationId) + allEnvironments.count
    }

    $scope.model.environments = [allEnvironments]

    $scope.model.all_environments = true
    $scope.select.environments = SERVER_ENVIRONMENT_SELECT
  }

  function _setRulesAndSeveritySelect() {
    rulesJobOutcomePolicyService.getRules().then((rulesList) => {
      $scope.select.rulesAndSeverities.push({
        name: $translate.instant(allRulesTranslationId),
        value: allValue,
        group: $translate.instant(allValue)
      })
      lodash.forEach(RULE_SEVERITY_LIST, (severity) => {
        $scope.select.rulesAndSeverities.push({
          name: $translate.instant(severity.translationId),
          value: severity.value,
          group: $translate.instant(severityLevelTranslationId)
        })
      })

      rulesList.reverse()
      lodash.forEach(rulesList, (rule) => {
        $scope.select.rulesAndSeverities.push({
          name: rule.title,
          value: rule.name,
          group: $translate.instant(assessRulesTranslationId)
        })
      })
    })
  }

  function _rulesAndSeverityInit() {
    $scope.model.rulesAndSeverities = []
    if ($scope.model.all_rules) {
      $scope.model.rulesAndSeverities.push({
        name: $translate.instant(allRulesTranslationId),
        value: allValue,
        number: $scope.model.all_rules_threshold
      })
    }

    lodash.forEach(Object.keys($scope.model.severities), (severityValue) => {
      const severity = lodash.find(RULE_SEVERITY_LIST, {
        value: severityValue
      })
      if (severity) {
        $scope.model.rulesAndSeverities.push({
          name: $translate.instant(severity.translationId),
          value: severity.value,
          number: $scope.model.severities[severityValue]
        })
      }
    })

    rulesJobOutcomePolicyService.getRules().then((rulesList) => {
      if ($scope.model.rules) {
        lodash.forEach(Object.keys($scope.model.rules), (ruleValue) => {
          const rule = lodash.find(rulesList, {
            name: ruleValue
          })
          if (rule) {
            $scope.model.rulesAndSeverities.push({
              name: rule.title,
              value: rule.name,
              number: $scope.model.rules[ruleValue]
            })
          }
        })
      }
    })
  }

  function _populateApplicationsBox() {
    $scope.applicationNameSelected = 'ID'
    $scope.model.all_applications = true
    $scope.model.app_criterion = 'ID'
    $scope.model.applicationOptions = $scope.model.applicationOptions[0]

    $scope.model.applicationChoice = $scope.model.applications
    $scope.select.applicationChoice = $scope.select.applications
  }

  function _getApplicationTags() {
    TagFactory.getApplicationsTags()
      .then((response) => {
        const tags: any[] = []
        lodash.forEach(response.data.tags, (tag) => {
          const tagObj = { name: tag, value: tag }
          tags.push(tagObj)
        })
        $scope.model.application_tags = []
        $scope.select.application_tags = tags
        ServiceUtils.handleResolve('data.tags')
      })
      .catch(ServiceUtils.handleError)
  }

  function applicationOptionsToString(item) {
    return $translate.instant(item.translationId)
  }

  function applicationChoiceToString(item) {
    return $translate.instant(item)
  }

  function environmentToString(item) {
    // eslint-disable-next-line unicorn/prefer-ternary
    if (item === allEnvironmentsTranslationId) {
      return $translate.instant(item) + ' ' + allEnvironments.count
    } else {
      return $translate.instant(item)
    }
  }

  function statusToString(item) {
    return $translate.instant(item)
  }

  function rulesToString(item) {
    return item
  }

  function getRulesGroup(item) {
    return item.group
  }

  init()
}

export function invalidTimeRange(startDate, endDate) {
  const today = new Date()
  if (endDate && startDate) {
    if (endDate.value === 0 || startDate.value === 0) {
      scope.invalidDate = false
      return false
    } else if (startDate.value === -1) {
      const endDateFromToday = today.getTime() - endDate.value * 1000
      if (endDate.value === -1) {
        if (startDate.date >= endDate.date) {
          scope.invalidDate = true
          return true
        } else {
          scope.invalidDate = false
          return false
        }
      } else if (startDate.date >= endDateFromToday) {
        scope.invalidDate = true
        return true
      }
    } else if (endDate.value === -1) {
      const startDateFromToday = today.getTime() - startDate.value * 1000
      if (startDateFromToday >= endDate.date) {
        scope.invalidDate = true
        return true
      }
    } else if (endDate.value >= startDate.value) {
      scope.invalidDate = true
      return true
    } else {
      scope.invalidDate = false
      return false
    }
  }
}

export function invalidRelativeEndTime(startDate, endDate) {
  if (endDate.value === -1 && startDate.value !== -1) {
    scope.invalidDate = true
    return true
  } else {
    scope.invalidDate = invalidTimeRange(startDate, endDate)
    return false
  }
}

export function selectStartDate(selected) {
  scope.model.start_date = selected.value
  if (selected.value === 0) {
    scope.model.include_all_start_dates = true
    scope.model.custom_start_date = false
    scope.model.is_job_start_time = false
  } else if (selected.value === -1) {
    scope.model.start_date = selected.date
    scope.model.include_all_start_dates = false
    scope.model.custom_start_date = true
    scope.model.is_job_start_time = false
  } else if (selected.value === -2) {
    scope.model.is_job_start_time = true
    scope.model.custom_start_date = false
    scope.model.include_all_start_dates = false
  } else {
    scope.model.include_all_start_dates = false
    scope.model.custom_start_date = false
    scope.model.is_job_start_time = false
  }
}

export function selectEndDate(selected) {
  if (selected.value === -1) {
    scope.model.end_date = selected.date
    scope.model.custom_end_date = true
  } else {
    scope.model.end_date = selected.value
    scope.model.custom_end_date = false
  }
}

// items = select, values = selected

export function mapItemsForMultiselect(
  items: Array<{
    readonly value: string
    readonly name: string
    readonly translationId: string
    readonly rankOrder?: number
    readonly group?: string
  }>,
  groupItems: boolean
) {
  const allItems: any[] = []
  if (groupItems) {
    const itemsToMatchOn = items
      .map((item) => item.group)
      .filter((value, index, self) => self.indexOf(value) === index)
    itemsToMatchOn.forEach((group) => {
      if (group) {
        allItems.push({ name: translate.instant(group), items: [] })
      }
    })
  } else {
    allItems.push({ name: undefined, items: [] })
  }

  items.forEach((item) => {
    allItems.forEach((group) => {
      if (group.name === translate.instant(item.group)) {
        group.items.push(item.translationId ? item.translationId : item.name)
      }
    })
  })
  return allItems
}

export function mapValuesForMultiselect(
  values: Array<{
    readonly value: string
    readonly name: string
    readonly translationId: string
    readonly rankOrder?: number
    readonly group?: string
  }>
) {
  const propValues: string[] = []
  if (values) {
    values.forEach((item) => {
      if (item) {
        propValues.push(item.translationId ? item.translationId : item.name)
      }
    })
  }
  return propValues
}

export function mapItemsForSingleSelect(items, groupItems) {
  const allItems: any[] = []
  if (groupItems) {
    const itemsToMatchOn = items
      .map((item) => item.group)
      .filter((value, index, self) => self.indexOf(value) === index)
    itemsToMatchOn.forEach((group) => {
      if (group) {
        allItems.push({ name: translate.instant(group), items: [] })
      }
    })
  } else {
    allItems.push({ name: undefined, items: [] })
  }

  items.forEach((item) => {
    allItems.forEach((group) => {
      if (group.name === item.group) {
        group.items.push({
          name: item.name,
          number: item.number,
          group: translate.instant(item.group),
          value: item.value,
          index: group.items.length
        })
      }
    })
  })
  return allItems
}

export function addSeverityOrRuleToModel(rulesAndSeverities) {
  scope.model.all_rules = lodash
    .map(rulesAndSeverities, 'value')
    .includes(allValue)
  scope.model.rulesAndSeverities = rulesAndSeverities
}

export function validateThreshold() {
  scope.invalidForm = lodash
    .map(scope.model.rulesAndSeverities, 'number')
    .some((threshold) => threshold && threshold < -1)
}
